import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@client/shared/shared.module';
import { BaseComponent } from '@shared/component/base/base.component';
import { TourService } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-tour',
  imports: [SharedModule],
  templateUrl: './tour.component.html',
  styleUrl: './tour.component.scss',
})
export class TourComponent extends BaseComponent implements OnInit {
  constructor(private tourService: TourService) {
    super();
  }

  ngOnInit(): void {
    this.tourService.setDefaults({
      asyncStepTimeout: 5000,
      backdropConfig: { offset: 5, backgroundColor: 'rgba(45, 57, 64, 0.3)' },
      enableBackdrop: true,
      isAsync: true,
      scrollContainer: '.content-wrapper',
      stepDimensions: { width: 'auto', maxWidth: '400px' },
      prevBtnTitle: 'Back',
      smoothScroll: true,
      delayBeforeStepShow: 500,
      delayAfterNavigation: 1000,
      duplicateAnchorHandling: 'registerFirst',
      // @TODO position breaks on scroll
      // centerAnchorOnScroll: false,
      // disablePageScrolling: true,
      // disableScrollToAnchor: true,
      // showProgress: false,
      // isOptional
      // nextOnAnchorClick: true,
      // closeOnOutsideClick: true
      // allowUserInitiatedNavigation
    });
  }
}
